import { Log } from '@devanjs/log';
import { computed } from 'vue';
import type { PossiblyAsyncIntegration } from './types/asyncIntegration';
import type { IntegrationsStore } from './types/integrationsStore';

export const useInstallation = <
  K extends keyof Integrations,
  Integrations extends Record<string, PossiblyAsyncIntegration>,
>(
  code: K,
  store: IntegrationsStore<Integrations>,
) => {
  const installation = store.installations[code];

  if (installation === undefined) {
    Log.red('Integrations').info(`Installation ${code.toString()} not found`);
  }

  return computed(() => installation);
};
